import { MediaRemoteVideoData } from '@generated/content';
import { TextMediaBox } from '@interfaces/config';
import { MediaTypesEnum } from '@interfaces/../enums/media-types.enum';
import { HttpHelper } from '@lib/utils';

export class YoutubeVideo {
  private readonly node: MediaRemoteVideoData = null;

  constructor(node: MediaRemoteVideoData = null) {
    this.node = node;
  }

  public getComponentConfig(): TextMediaBox.MediaYoutubeVideoConfig {
    if (!this.node) {
      return null;
    }

    const caption = this.node.attributes.field_title;
    const videoId = this.extractYoutubeVideoId();

    if (!videoId) {
      return null;
    }

    return { videoId, caption, type: MediaTypesEnum.YOUTUBE_VIDEO };
  }

  private extractYoutubeVideoId(): string {
    const url = this.node.attributes?.field_media_oembed_video || '';
    return HttpHelper.extractYoutubeVideoId(url);
  }
}
